import { Menu, MenuItem, Button } from "@aws-amplify/ui-react"
import { useNavigate } from "react-router-dom"

const ExerciseDetailsHeader = ({ exercise, onDelete, onFavoriteClicked, isLoading }) => {
    const navigate = useNavigate()
    return (
        <div className="d-flex justify-content-between align-items-center my-2">
            <div className="d-flex align-items-center">

                <Button
                    variation="link"
                    colorTheme="overlay"
                    loadingText="Loading.."
                    isLoading={isLoading}
                    onClick={() => { navigate(`/exercises/${exercise.id}/edit`) }}>
                    <h5 className="m-0">{exercise?.name}</h5>
                </Button>
                {exercise &&
                    <Button className="no-border ms-2" onClick={() => {
                        onFavoriteClicked()
                    }
                    }>

                        {!exercise?.favorite &&
                            <span className="material-symbols-outlined">
                                favorite
                            </span>}
                        {exercise?.favorite &&
                            <span className="material-symbols-outlined" style={{ fontVariationSettings: "'FILL' 1" }}>
                                favorite
                            </span>}
                    </Button>}

            </div>
            <Menu
                menuAlign="end"
            >
                <MenuItem onClick={() => {
                    onDelete(exercise.id)
                    navigate(`/exercises`)
                }}>
                    Delete Exercise
                </MenuItem>
                <MenuItem onClick={() => {
                    navigate(`/exercises/${exercise.id}/edit`)
                }

                }>
                    Edit Exercise
                </MenuItem>
            </Menu>
        </div>
    )
}

export default ExerciseDetailsHeader